import React, { Fragment } from "react";
import Autocomplete, {
  createFilterOptions
} from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { fieldExistsOnPlayType, getInputError } from "games/utils";
import { isDisplayable } from "util/misc";

const filterOptions = createFilterOptions({
  matchFrom: "start"
});

const PlayAutocompleteInput = ({
  inputName,
  label,
  handleDropdownChange,
  play,
  options,
  inputRef = null,
  classes,
  autoFocus
}) => {
  const error = getInputError(inputName, play[inputName]);
  const showField =
    inputName === "playType" || fieldExistsOnPlayType(play.playType, inputName);

  const autoCompleteComp =
    inputName === "playType" ? (
      <Autocomplete
        filterOptions={filterOptions}
        autoSelect={true}
        autoHighlight={true}
        className={classes.input}
        id={inputName}
        options={options}
        getOptionLabel={(option) => {
          if (!isDisplayable(option)) return "";
          if (option.name) return option.name;
          const thisOption = options.find((o) => o.id === option);
          return thisOption ? thisOption.name : "";
        }}
        style={{ width: 220 }}
        value={play[inputName] || ""}
        onChange={(event, newValue) =>
          handleDropdownChange(event, newValue, inputName)
        }
        renderInput={(params) => {
          return (
            <TextField
              autoFocus={autoFocus ? true : false}
              {...params}
              inputRef={inputRef}
              label={label}
              error={error.isError}
              helperText={error.message}
              variant="filled"
            />
          );
        }}
      />
    ) : (
      <Autocomplete
        autoSelect={true}
        autoHighlight={true}
        className={classes.input}
        id={inputName}
        options={options}
        getOptionLabel={(option) => {
          if (!isDisplayable(option)) return "";
          if (option.name) return option.name;
          const thisOption = options.find((o) => o.id === option);
          return thisOption ? thisOption.name : "";
        }}
        style={{ width: 220 }}
        value={play[inputName] || ""}
        onChange={(event, newValue) =>
          handleDropdownChange(event, newValue, inputName)
        }
        renderInput={(params) => {
          return (
            <TextField
              autoFocus={autoFocus ? true : false}
              {...params}
              inputRef={inputRef}
              label={label}
              error={error.isError}
              helperText={error.message}
              variant="filled"
            />
          );
        }}
      />
    );

  return <Fragment>{showField && autoCompleteComp}</Fragment>;
};

export default PlayAutocompleteInput;
